import { registerPlugin } from "@capacitor/core";
const IronSource = registerPlugin("IronSource", {
    web: () => import("./web").then(m => new m.IronSourceWeb()),
});
export * from "./definitions";
export { IronSource };
